import { DEFAULT_RAW_FAX_PROGRAM_CODE } from "lookup/RawConstants";

const normalizeSearch = (search = "") => {
  if (!search) {
    return "";
  }

  return search.startsWith("?") ? search : `?${search}`;
};

export const getRawListRedirectPath = (
  listQueryParams = "",
  faxProgramCode = DEFAULT_RAW_FAX_PROGRAM_CODE
) => {
  if (listQueryParams) {
    return `/raw/list${normalizeSearch(listQueryParams)}`;
  }

  if (!faxProgramCode) {
    return "/raw/list";
  }

  return `/raw/list?${new URLSearchParams({ faxProgramCode }).toString()}`;
};

export const appendListQueryParamsToPath = (path, listQueryParams = "") => {
  if (!listQueryParams) {
    return path;
  }

  return `${path}${normalizeSearch(listQueryParams)}`;
};

export const buildRawDispositionPath = (rawId, listQueryParams = "") =>
  appendListQueryParamsToPath(`/raw/${rawId}`, listQueryParams);

export const buildSwitchDispositionPath = (
  rawId,
  faxProgramCode = DEFAULT_RAW_FAX_PROGRAM_CODE
) =>
  `/switch/disposition/${rawId}?${new URLSearchParams({
    faxProgramCode,
  }).toString()}`;
